import {Notyf} from "notyf";
import axios from 'axios';
import Swiper from 'swiper';
import SwiperCore, {Navigation, Pagination, Thumbs} from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Thumbs]);

export class CompareCars {
    constructor(lazy)
    {
        this.manage_list = new ManageCompareList();
        this.cars_list_front = new showCompareCars(lazy);
    }

    init()
    {
        this.manage_list.init();
        this.cars_list_front.init();
    }

    updateButtons()
    {
        this.manage_list._initListeners();
    }

}


export class showCompareCars {
    constructor(lazy = false)
    {
        this.compare_wrapper = document.querySelector('[data-compare-cars]');
        this.loader = document.querySelector('[data-cars-loader]');
        this.loader_active = true;
        this.localStorageKeyName = 'compare_cars';
        this.lazy = lazy;
        this.slider = false;
    }

    init()
    {
        if (!this.compare_wrapper) {
            return false;
        }

        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
        if (current_data === null || !current_data || !current_data.length) {
            document.querySelector('[data-compare-cars]').innerHTML = '<p class="text-center w-full block">Brak wskazanych ofert.</p>';
            this.toggleLoader();
            return false;
        }

        this._showCars(current_data);
        this._compareCarSlider();
    }

    refreshCars()
    {
        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
        if (current_data === null || !current_data || !current_data.length) {
            this.toggleLoader();
            window.location.reload();
            return false;
        }

        this._showCars(current_data);
    }


    toggleLoader()
    {

        console.log("-> this.loader_active", this.loader_active);
        if (!this.loader) {
            return false;
        }
        console.log("-> this.loader_active", this.loader_active);



        if (this.loader_active) {
            this.loader.style.cssText = '';
            this.loader.style.display = 'none';
        } else {
            this.loader.style.display = 'flex';
        }

        this.loader_active = !this.loader_active;
    }

    _compareCarSlider()
    {

        this.slider = new Swiper(".js-compares-slider", {
            spaceBetween: 32,
            slidesPerView: 1,
            watchSlidesProgress: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            breakpoints: {
              // when window width is >= 640px
                768: {
                    slidesPerView: 2,
                },
                1100: {
                    slidesPerView: 3,
                }
            }
        });

        this.slider.init();
    }

    _showCars(current_data)
    {
        const ajax_form_data = new FormData();
        ajax_form_data.append('action', 'compareCars');


        for (let i = 0; i < current_data.length; i++) {
            ajax_form_data.append('ids[]', current_data[i]);
        }

        let that = this;
        axios.post(ajax_object.ajax_url, ajax_form_data)
        .then(function (response) {
            console.log(response);
            document.querySelector('[data-compare-cars]').innerHTML = '';
            document.querySelector('[data-compare-cars]').innerHTML = response.data;
            if (that.lazy) {
                that.lazy.update();
            }
            that._updateListeners();
            that.toggleLoader();
            that.slider.update();


        })
        .catch(error => {
            console.log(error.response.data.error);
            that.toggleLoader();
        })

    }

    _updateListeners()
    {
        const events = new ManageCompareList();
        events._initListeners();
    }

}


export class ManageCompareList {
    constructor()
    {
        this.add_to_compare_buttons = document.getElementsByClassName('js-add-car-to-compare');
        this.max_slots = 3;
        this.current_slots = 0;
        this.localStorageKeyName = 'compare_cars';
        this.remove_from_compare_buttons = document.getElementsByClassName('js-remove-car-from-compare');
        this.compare_badge = document.querySelector('.js-compare-button');

        this.notyf = new Notyf({
            duration: 3000,
        });

    }

    init()
    {

        if (!this.add_to_compare_buttons) {
            return false;
        }

        this._initListeners();
        this._toggleCompareBadge();
    }



    _toggleCompareBadge()
    {
        this.current_slots = this._getCarsCount();

        if (!this.compare_badge) {
            return false;
        }

        if (this.current_slots) {
            this._animateVisibility(this.compare_badge, true);
        }
    }

    _animateVisibility(element, show)
    {
        if (show) {
            element.style.display = 'flex';
            element.style.opacity = '1';
        }
    }

    _getCarsCount()
    {
        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
        if (current_data === null || !current_data || !current_data.length) {
            return false;
        }

      current_data.forEach((car) => {
            const url = window?.ajax_object?.apiUrl || '';
            if (!url) {
                return;
            }

            fetch(url + car)
            .then((res) => {
                if (!res.ok) {
                    this._removeCarFromList(car, true);
                }
            })
            .catch(err => {
                console.log(err);
            })
            })


        return JSON.parse(localStorage.getItem(this.localStorageKeyName));

    }

    _initListeners()
    {

        for (let i = 0; i < this.add_to_compare_buttons.length; i++) {
            this.add_to_compare_buttons[i].addEventListener('click', () => {
                const id = this.add_to_compare_buttons[i].dataset.carId;

                if (this._checkEmptySlot(id)) {
                    this._addCarToCompare(id);
                }
            });
        }

        console.log(this.remove_from_compare_buttons.length);
        for (let i = 0; i < this.remove_from_compare_buttons.length; i++) {
            this.remove_from_compare_buttons[i].addEventListener('click', () => {
                const id = this.remove_from_compare_buttons[i].dataset.carId;

                if (this._removeCarFromList(id)) {
                    const compare_view = new showCompareCars();
                    compare_view.refreshCars();
                }
            });
        }
    }


    _removeCarFromList(id, silent = false)
    {
        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));

        var index = current_data.indexOf(id);
        if (index !== -1) {
            current_data.splice(index, 1);
            localStorage.setItem(this.localStorageKeyName, JSON.stringify(current_data));

            if (!silent) {
                this.notyf.success('Oferta usunięta.');
            }
            this._toggleCompareBadge();
            return true
        } else {
            if (!silent) {
                this.notyf.error('Wystąpił błąd...');
            }
        }

        return false;
    }

    _checkEmptySlot(id)
    {
        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
        if (current_data) {
            if (current_data.length >= this.max_slots) {
                this.notyf.error('Możesz dodać maksymalnie 3 auta. Usuń inne auto.');
                return false;
            }

            if (current_data.includes(id)) {
                this.notyf.error('To auto jest już dodane.');
                return false;
            }

            return true;
        }
        return true;
    }

    _addCarToCompare(id)
    {
        let current_data = JSON.parse(localStorage.getItem(this.localStorageKeyName));
        current_data = ( current_data === null) ? [] : current_data;

        current_data.push(id);
        localStorage.setItem(this.localStorageKeyName, JSON.stringify(current_data));
        this._toggleCompareBadge();
        this.notyf.success('Dodano do porównania.');
    }

}
